// src/app/redux/actions/skillEvaluationActions.js

export const FETCH_SKILL_EVALS_BY_CAMPAGNE_REQUEST = "FETCH_SKILL_EVALS_BY_CAMPAGNE_REQUEST";
export const FETCH_SKILL_EVALS_BY_CAMPAGNE_SUCCESS = "FETCH_SKILL_EVALS_BY_CAMPAGNE_SUCCESS";
export const FETCH_SKILL_EVALS_BY_CAMPAGNE_FAIL    = "FETCH_SKILL_EVALS_BY_CAMPAGNE_FAIL";

export const FETCH_SKILL_EVALS_BY_USER_REQUEST = "FETCH_SKILL_EVALS_BY_USER_REQUEST";
export const FETCH_SKILL_EVALS_BY_USER_SUCCESS = "FETCH_SKILL_EVALS_BY_USER_SUCCESS";
export const FETCH_SKILL_EVALS_BY_USER_FAIL    = "FETCH_SKILL_EVALS_BY_USER_FAIL";

export const CREATE_SKILL_EVAL_REQUEST = "CREATE_SKILL_EVAL_REQUEST";
export const CREATE_SKILL_EVAL_SUCCESS = "CREATE_SKILL_EVAL_SUCCESS";
export const CREATE_SKILL_EVAL_FAIL    = "CREATE_SKILL_EVAL_FAIL";

export const UPDATE_SKILL_EVAL_REQUEST = "UPDATE_SKILL_EVAL_REQUEST";
export const UPDATE_SKILL_EVAL_SUCCESS = "UPDATE_SKILL_EVAL_SUCCESS";
export const UPDATE_SKILL_EVAL_FAIL    = "UPDATE_SKILL_EVAL_FAIL";

export const DELETE_SKILL_EVAL_REQUEST = "DELETE_SKILL_EVAL_REQUEST";
export const DELETE_SKILL_EVAL_SUCCESS = "DELETE_SKILL_EVAL_SUCCESS";
export const DELETE_SKILL_EVAL_FAIL    = "DELETE_SKILL_EVAL_FAIL";

export const SUBMIT_AUTO_EVAL_REQUEST = "SUBMIT_AUTO_EVAL_REQUEST";
export const SUBMIT_AUTO_EVAL_SUCCESS = "SUBMIT_AUTO_EVAL_SUCCESS";
export const SUBMIT_AUTO_EVAL_FAIL    = "SUBMIT_AUTO_EVAL_FAIL";

export const SKILL_MANAGER_DECISION_REQUEST = "SKILL_MANAGER_DECISION_REQUEST";
export const SKILL_MANAGER_DECISION_SUCCESS = "SKILL_MANAGER_DECISION_SUCCESS";
export const SKILL_MANAGER_DECISION_FAIL    = "SKILL_MANAGER_DECISION_FAIL";

export const SKILL_RF_DECISION_REQUEST = "SKILL_RF_DECISION_REQUEST";
export const SKILL_RF_DECISION_SUCCESS = "SKILL_RF_DECISION_SUCCESS";
export const SKILL_RF_DECISION_FAIL    = "SKILL_RF_DECISION_FAIL";

export const FETCH_SKILL_MANAGER_INBOX_REQUEST = "FETCH_SKILL_MANAGER_INBOX_REQUEST";
export const FETCH_SKILL_MANAGER_INBOX_SUCCESS = "FETCH_SKILL_MANAGER_INBOX_SUCCESS";
export const FETCH_SKILL_MANAGER_INBOX_FAIL    = "FETCH_SKILL_MANAGER_INBOX_FAIL";

export const FETCH_SKILL_RF_INBOX_REQUEST = "FETCH_SKILL_RF_INBOX_REQUEST";
export const FETCH_SKILL_RF_INBOX_SUCCESS = "FETCH_SKILL_RF_INBOX_SUCCESS";
export const FETCH_SKILL_RF_INBOX_FAIL    = "FETCH_SKILL_RF_INBOX_FAIL";

export const SET_SKILL_EVAL_LOADING  = "SET_SKILL_EVAL_LOADING";
export const CLEAR_SKILL_EVAL_ERROR  = "CLEAR_SKILL_EVAL_ERROR";

// Action creators
export const fetchSkillEvalsByCampagneRequest = (campagneId) => ({ type: FETCH_SKILL_EVALS_BY_CAMPAGNE_REQUEST, payload: { campagneId } });
export const fetchSkillEvalsByCampagneSuccess = (data)       => ({ type: FETCH_SKILL_EVALS_BY_CAMPAGNE_SUCCESS, payload: data });
export const fetchSkillEvalsByCampagneFail    = (error)      => ({ type: FETCH_SKILL_EVALS_BY_CAMPAGNE_FAIL, error });

export const fetchSkillEvalsByUserRequest = (userId) => ({ type: FETCH_SKILL_EVALS_BY_USER_REQUEST, payload: { userId } });
export const fetchSkillEvalsByUserSuccess = (data)   => ({ type: FETCH_SKILL_EVALS_BY_USER_SUCCESS, payload: data });
export const fetchSkillEvalsByUserFail    = (error)  => ({ type: FETCH_SKILL_EVALS_BY_USER_FAIL, error });

export const createSkillEvalRequest = (payload) => ({ type: CREATE_SKILL_EVAL_REQUEST, payload });
export const createSkillEvalSuccess = (data)    => ({ type: CREATE_SKILL_EVAL_SUCCESS, payload: data });
export const createSkillEvalFail    = (error)   => ({ type: CREATE_SKILL_EVAL_FAIL, error });

export const updateSkillEvalRequest = (id, payload) => ({ type: UPDATE_SKILL_EVAL_REQUEST, payload: { id, payload } });
export const updateSkillEvalSuccess = (data)        => ({ type: UPDATE_SKILL_EVAL_SUCCESS, payload: data });
export const updateSkillEvalFail    = (error)       => ({ type: UPDATE_SKILL_EVAL_FAIL, error });

export const deleteSkillEvalRequest = (id)    => ({ type: DELETE_SKILL_EVAL_REQUEST, payload: { id } });
export const deleteSkillEvalSuccess = (id)    => ({ type: DELETE_SKILL_EVAL_SUCCESS, payload: { id } });
export const deleteSkillEvalFail    = (error) => ({ type: DELETE_SKILL_EVAL_FAIL, error });

export const setSkillEvalLoading = (loading) => ({ type: SET_SKILL_EVAL_LOADING, payload: loading });
export const clearSkillEvalError = ()        => ({ type: CLEAR_SKILL_EVAL_ERROR });

export const submitAutoEvalRequest = (id) => ({ type: SUBMIT_AUTO_EVAL_REQUEST, payload: { id } });
export const submitAutoEvalSuccess = (data) => ({ type: SUBMIT_AUTO_EVAL_SUCCESS, payload: data });
export const submitAutoEvalFail    = (error) => ({ type: SUBMIT_AUTO_EVAL_FAIL, error });

export const managerDecisionRequest = (id, payload) => ({ type: SKILL_MANAGER_DECISION_REQUEST, payload: { id, payload } });
export const managerDecisionSuccess = (data) => ({ type: SKILL_MANAGER_DECISION_SUCCESS, payload: data });
export const managerDecisionFail    = (error) => ({ type: SKILL_MANAGER_DECISION_FAIL, error });

export const rfDecisionRequest = (id, payload) => ({ type: SKILL_RF_DECISION_REQUEST, payload: { id, payload } });
export const rfDecisionSuccess = (data) => ({ type: SKILL_RF_DECISION_SUCCESS, payload: data });
export const rfDecisionFail    = (error) => ({ type: SKILL_RF_DECISION_FAIL, error });

export const fetchManagerInboxRequest = () => ({ type: FETCH_SKILL_MANAGER_INBOX_REQUEST });
export const fetchManagerInboxSuccess = (data) => ({ type: FETCH_SKILL_MANAGER_INBOX_SUCCESS, payload: data });
export const fetchManagerInboxFail    = (error) => ({ type: FETCH_SKILL_MANAGER_INBOX_FAIL, error });

export const fetchRfInboxRequest = () => ({ type: FETCH_SKILL_RF_INBOX_REQUEST });
export const fetchRfInboxSuccess = (data) => ({ type: FETCH_SKILL_RF_INBOX_SUCCESS, payload: data });
export const fetchRfInboxFail    = (error) => ({ type: FETCH_SKILL_RF_INBOX_FAIL, error });